import React, {useState} from 'react';
import {AnnouncementItems} from '../consts/types';
import {AnnouncementWelcomeDialog} from './AnnouncementWelcomeDialog';
import {AnnouncementDialog} from './AnnouncementDialog';
import {checkIsWelcome, getAnnouncements, getWelcomePage} from './utils';

interface AnnouncementProps {
    announcements: AnnouncementItems[];
    onMessageSeen: (announcementVersion: string, showNextTime: boolean) => Promise<void>;
    announcementVersion: string;
    defaultOpen?: boolean;
}

export const Announcement = (props: AnnouncementProps) => {
    const {announcements, onMessageSeen, announcementVersion, defaultOpen = true} = props;
    const [isWelcome, setIsWelcome] = useState(checkIsWelcome(announcements[0]));
    const [isOpen, setIsOpen] = useState(defaultOpen);

    const welcomePage = getWelcomePage(announcements);
    const announcementsPages = getAnnouncements(announcements);

    const onClose = () => {
        onMessageSeen(announcementVersion, false);
        setIsOpen(false);
    };

    const onForward = () => {
        setIsWelcome(false);
    };

    if (!isOpen) return null;

    if (isWelcome) {
        return (
            <AnnouncementWelcomeDialog
                welcomeAnnouncement={welcomePage}
                onClose={onClose}
                onForward={onForward}
            />
        );
    }
    return (
        <AnnouncementDialog
            announcement={announcementsPages}
            onClose={onClose}
            toWelcomePage={setIsWelcome}
        />
    );
};
